// extracted by mini-css-extract-plugin
module.exports = {"viewMoreSection":"styles_viewMoreSection__20+lQ","viewMore":"styles_viewMore__yWns3","container":"styles_container__3Mat7"};